import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

interface PropsInterface {
  className?: string;
  contentClassName?: string;
  title?: string;
  saveDisabled?: boolean;
  dirty: boolean;
  cancel: () => void;
  save: () => void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FormCard',
  props: {
    className: {},
    contentClassName: {},
    title: {},
    saveDisabled: { type: Boolean },
    dirty: { type: Boolean },
    cancel: { type: Function },
    save: { type: Function }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    class: _normalizeClass(["form-card p-fluid", [__props.className, { editing: __props.dirty }]])
  }, _createSlots({
    content: _withCtx(() => [
      _renderSlot(_ctx.$slots, "form")
    ]),
    footer: _withCtx(() => [
      (props.dirty)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_AppButton, {
              id: "cancel_btn",
              type: "secondary",
              text: "Cancel",
              onClick: __props.cancel
            }, null, 8, ["onClick"]),
            _createVNode(_component_AppButton, {
              id: "save_btn",
              type: "primary",
              text: "Save",
              disabled: !!props.saveDisabled,
              onClick: __props.save
            }, null, 8, ["disabled", "onClick"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (props.title)
      ? {
          name: "header",
          fn: _withCtx(() => [
            _createElementVNode("h2", null, _toDisplayString(__props.title), 1)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["class"]))
}
}

})